import { createContext as e } from "react";
//#region src/components/ScrollContainer/ScrollContainerContext.ts
var t = e(void 0);
//#endregion
export { t as ScrollContainerContext };
